import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppFormsModule } from '../../../forms/forms.module';
import { MaterialModule } from '../../../material.module';
import { SharedModule } from '../../../shared/shared.module';
import { GrocyProductActionsModule } from '../product-actions/product-actions.module';
import { CurrentStockComponent } from './components/current-stock/current-stock.component';
import { ProductSelectComponent } from './components/product-select/product-select.component';
import { StockTableComponent } from './components/stock-table/stock-table.component';

@NgModule({
  declarations: [CurrentStockComponent, ProductSelectComponent, StockTableComponent],
  imports: [
    AppFormsModule,
    CommonModule,
    FormsModule,
    GrocyProductActionsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
  ],
  exports: [CurrentStockComponent, ProductSelectComponent],
})
export class GrocySharedModule {}
